import React, { Component } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { VFBanner } from '@vfgroup-oneplatform/foundation/Components';
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import ChangeDeviceNameModal from '../../../CommonUI/ChangeDeviceName/ChangeDeviceNameModal';
import Images from '../../../Themes/Images';

import styles from './DeviceNameBanner.Styles';

class DeviceNameBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldShowChangeDeviceName: false,
    };
  }

  onCloseQuickAction = () => {
    _.isFunction(this.props.onCloseQuickAction) && this.props.onCloseQuickAction();
    this.setState({ shouldShowChangeDeviceName: false });
  };

  renderCVM = () => {
    return (
      <VFBanner
        title={'cvm_device_name_title'}
        description={'cvm_device_name_description'}
        primaryButtonTitle={'cvm_device_name_primary_button_title'}
        onPrimaryButtonPress={() =>
          this.setState({
            shouldShowChangeDeviceName: !this.state.shouldShowChangeDeviceName,
          })
        }
        withSecondaryButton={true}
        secondaryButtonTitle={'cvm_device_name_secondary_button_title'}
        onSecondaryButtonPress={() => {
          this.props.onMayBeLaterPress();
        }}
        leftIconSize={25}
        withLeftIcon={true}
        withCloseButton={false}
        leftIcon={Images.ic_mobile}
        descriptionStyle={[styles.descriptionStyle]}
        backgroundColors={[Colors.darkCyan, Colors.turquoise]}
        containerViewStyle={styles.containerViewStyle}
      />
    );
  };

  renderMaybeLater = () => {
    return (
      <VFBanner
        title={'cvm_device_name_title'}
        description={'cvm_device_name_dismissed_description'}
        withPrimaryButton={false}
        withSecondaryButton={false}
        leftIconSize={25}
        withLeftIcon={true}
        withCloseButton={true}
        leftIcon={Images.touch_screen}
        descriptionStyle={[styles.descriptionStyle]}
        backgroundColors={[Colors.darkCyan, Colors.turquoise]}
        containerViewStyle={styles.containerViewStyle}
      />
    );
  };

  render() {
    const { onDeviceNameChange, isMayBeLaterBanner } = this.props;
    return (
      <>
        <ChangeDeviceNameModal
          isVisible={this.state.shouldShowChangeDeviceName}
          onDeviceNameChange={onDeviceNameChange}
          onCloseQuickAction={this.onCloseQuickAction}
        />
        {isMayBeLaterBanner ? this.renderMaybeLater() : this.renderCVM()}
      </>
    );
  }
}

DeviceNameBanner.defaultProps = {};
DeviceNameBanner.propTypes = {
  onDeviceNameChange: PropTypes.func,
  onMayBeLaterPress: PropTypes.func,
  isMayBeLaterBanner: PropTypes.bool,
  onCloseQuickAction: PropTypes.func,
};

export default DeviceNameBanner;
